__turbopack_context__.v({
  "admin-bg-danger": "TextMedia-module-scss-module__2edqBa__admin-bg-danger",
  "admin-bg-info": "TextMedia-module-scss-module__2edqBa__admin-bg-info",
  "admin-bg-primary": "TextMedia-module-scss-module__2edqBa__admin-bg-primary",
  "admin-bg-secondary": "TextMedia-module-scss-module__2edqBa__admin-bg-secondary",
  "admin-bg-success": "TextMedia-module-scss-module__2edqBa__admin-bg-success",
  "admin-bg-warning": "TextMedia-module-scss-module__2edqBa__admin-bg-warning",
  "admin-border": "TextMedia-module-scss-module__2edqBa__admin-border",
  "admin-border-dark": "TextMedia-module-scss-module__2edqBa__admin-border-dark",
  "admin-border-light": "TextMedia-module-scss-module__2edqBa__admin-border-light",
  "admin-rounded": "TextMedia-module-scss-module__2edqBa__admin-rounded",
  "admin-rounded-full": "TextMedia-module-scss-module__2edqBa__admin-rounded-full",
  "admin-rounded-lg": "TextMedia-module-scss-module__2edqBa__admin-rounded-lg",
  "admin-rounded-md": "TextMedia-module-scss-module__2edqBa__admin-rounded-md",
  "admin-rounded-sm": "TextMedia-module-scss-module__2edqBa__admin-rounded-sm",
  "admin-shadow-lg": "TextMedia-module-scss-module__2edqBa__admin-shadow-lg",
  "admin-shadow-md": "TextMedia-module-scss-module__2edqBa__admin-shadow-md",
  "admin-shadow-sm": "TextMedia-module-scss-module__2edqBa__admin-shadow-sm",
  "admin-sr-only": "TextMedia-module-scss-module__2edqBa__admin-sr-only",
  "admin-text-light": "TextMedia-module-scss-module__2edqBa__admin-text-light",
  "admin-text-muted": "TextMedia-module-scss-module__2edqBa__admin-text-muted",
  "admin-text-primary": "TextMedia-module-scss-module__2edqBa__admin-text-primary",
  "admin-text-secondary": "TextMedia-module-scss-module__2edqBa__admin-text-secondary",
  "text-media__container": "TextMedia-module-scss-module__2edqBa__text-media__container",
  "text-media__container--no-bottom": "TextMedia-module-scss-module__2edqBa__text-media__container--no-bottom",
  "text-media__container--no-top": "TextMedia-module-scss-module__2edqBa__text-media__container--no-top",
  "text-media__container--no-vertical": "TextMedia-module-scss-module__2edqBa__text-media__container--no-vertical",
  "text-media__container--reverse": "TextMedia-module-scss-module__2edqBa__text-media__container--reverse",
  "text-media__content": "TextMedia-module-scss-module__2edqBa__text-media__content",
  "text-media__description": "TextMedia-module-scss-module__2edqBa__text-media__description",
  "text-media__media-wrapper": "TextMedia-module-scss-module__2edqBa__text-media__media-wrapper",
  "text-media__subtitle": "TextMedia-module-scss-module__2edqBa__text-media__subtitle",
  "text-media__text": "TextMedia-module-scss-module__2edqBa__text-media__text",
  "text-media__title": "TextMedia-module-scss-module__2edqBa__text-media__title",
  "text-media__title--has-subtitle": "TextMedia-module-scss-module__2edqBa__text-media__title--has-subtitle",
  "text-media__vimeo-wrapper": "TextMedia-module-scss-module__2edqBa__text-media__vimeo-wrapper",
});
